import sensors from "sa-sdk-javascript";
import { getUserInfoByUserNo } from "@/api/MYINCOME";
import { getPageName } from "@/utils/MYINCOME/pageNameMap";

// 根据环境动态设置 server_url
const isProduction = process.env.REACT_APP_ENV === "production";
const serverUrl = isProduction
  ? "https://d.mingchu.co/sa?project=shinho_employee_project"
  : "https://d.mingchu.co/sa";

sensors.init({
  server_url: serverUrl,
  is_track_single_page: false, // 关闭自动采集单页面，改为手动触发
  use_client_time: true,
  send_type: "beacon",
  // show_log: true,
  heatmap: {
    //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
    clickmap: "default",
    //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
    scroll_notice_map: "not_collect", // 关闭自动采集 $WebStay，改为手动触发 PageStay
  },
});

// 从 URL 获取参数
const urlParams = new URLSearchParams(window.location.search);
const userNo = urlParams.get('userNo');

// 先注册基础属性
sensors.registerPage({
  system_platform: "PLRS-MYINCOME",
  user_code: userNo || ''
});

// 先暴露 sensors 对象，供其他组件使用
window.$sensors = { sensors };

/**
 * 发送自定义 PageView 事件
 */
const sendPageView = (userName = '') => {
  const pathname = window.location.pathname;
  sensors.track('PageView', {
    page_url: window.location.href,
    page_path: pathname,
    page_name: getPageName(pathname),
    page_title: document.title,
    user_name: userName,
  });
};

/**
 * 发送按钮点击事件
 * @param {string} buttonName - 按钮名称（如：查看）
 * @param {string} buttonDesc - 按钮备注/描述（如：销量绩效工资-202512-查看）
 * @param {string} buttonPage - 按钮所在页面
 */
export const trackButtonClick = (buttonName, buttonDesc, buttonPage) => {
  sensors.track('ButtonClick', {
    button_name: buttonName,
    button_desc: buttonDesc,
    button_page: buttonPage,
  });
};

// 调用接口获取用户信息，然后发送 PageView 事件
if (userNo) {
  getUserInfoByUserNo(userNo).then(res => {
    // 注册 user_name 到所有事件中
    sensors.registerPage({
      user_name: res?.data?.userName || '',
    });
    // 发送自定义 PageView 事件
    sendPageView(res?.data?.userName || '');
  }).catch(err => {
    console.error('获取用户信息失败:', err);
    sendPageView();
  });
} else {
  sendPageView();
}